<template>
  <svg class="app-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <path v-for="(path, index) in paths" :key="index" :d="path" />
  </svg>
</template>
<script>
const handset =
  'M21.5 16.4v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 1.6 3.7 2 2 0 0 1 3.6 1.5h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.5 2.1L7.6 9.4a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2z'
const icons = {
  home: ['M3 10 12 3l9 7v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1Z', 'M9 21v-8h6v8'],
  calendar: [
    'M4 6.5A2.5 2.5 0 0 1 6.5 4h11A2.5 2.5 0 0 1 20 6.5v12a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 4 18.5Z',
    'M8 2.5v3M16 2.5v3M4 9.5h16',
    'M8 13h1M12 13h1M16 13h1M8 17h1M12 17h1'
  ],
  today: [
    'M4 6.5A2.5 2.5 0 0 1 6.5 4h11A2.5 2.5 0 0 1 20 6.5v12a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 4 18.5Z',
    'M8 2.5v3M16 2.5v3M4 9.5h16',
    'm9 15 2 2 4-4'
  ],
  users: [
    'M15.5 20v-1.5a4 4 0 0 0-4-4h-5a4 4 0 0 0-4 4V20',
    'M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7',
    'M21.5 20v-1.5a4 4 0 0 0-3-3.9M15.5 4.1a3.5 3.5 0 0 1 0 6.8'
  ],
  dial: ['M15 3h6v6M21 3l-7 7', handset],
  bell: ['M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9', 'M10 21h4'],
  user: ['M4 21c.8-4 4-6 8-6s7.2 2 8 6', 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8'],
  arrow: ['m9 6 6 6-6 6'],
  back: ['m15 5-7 7 7 7'],
  down: ['m6 9 6 6 6-6'],
  'to-top': ['M5 4h14', 'm6 13 6-6 6 6M12 7v13'],
  plus: ['M12 5v14M5 12h14'],
  search: ['m20 20-3.6-3.6', 'M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14'],
  filter: ['M4 6h16M7 12h10M10 18h4'],
  phone: [handset],
  edit: ['m16 3 5 5-12 12-6 1 1-6Z', 'm14 5 5 5'],
  clock: ['M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18', 'M12 7v5l3 2'],
  check: ['m5 12 5 5 9-10'],
  task: [
    'M9 4H6a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-3',
    'M9 2.5h6v3H9Z',
    'm9 13.5 2 2 4-4.5'
  ],
  building: [
    'M5 21V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v17M2.5 21h19',
    'M9 7h1M14 7h1M9 11h1M14 11h1M9 15h1M14 15h1M10 21v-3h4v3'
  ],
  spark: [
    'M11 2.5c.4 3.6 1.9 5.9 6.5 6.5-4.6.6-6.1 2.9-6.5 6.5-.4-3.6-1.9-5.9-6.5-6.5 4.6-.6 6.1-2.9 6.5-6.5Z',
    'M18.5 14c.2 1.8.9 2.8 2.5 3-1.6.2-2.3 1.2-2.5 3-.2-1.8-.9-2.8-2.5-3 1.6-.2 2.3-1.2 2.5-3Z'
  ],
  mic: [
    'M12 14a3 3 0 0 0 3-3V6a3 3 0 0 0-6 0v5a3 3 0 0 0 3 3Z',
    'M5.5 11a6.5 6.5 0 0 0 13 0M12 17.5V21'
  ],
  expand: ['M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7'],
  shrink: ['M4 14h6v6M20 10h-6V4M14 10l7-7M3 21l7-7'],
  keyboard: ['M2 5h20v14H2Z', 'M5 9h1M9 9h1M13 9h1M17 9h1M5 13h1M9 13h1M13 13h1M17 13h1M7 16h10'],
  refresh: ['M20 7v5h-5M4 17v-5h5', 'M6 7a7 7 0 0 1 12-2l2 3M4 16l2 3a7 7 0 0 0 12-2'],
  logout: ['M9 3H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h5', 'M10 12h11m-4-4 4 4-4 4'],
  shield: ['m12 2.5 8 3.5v6c0 5-8 9.5-8 9.5S4 17 4 12V6Z', 'm8.5 12 2.5 2.5 4.5-5'],
  close: ['m6 6 12 12M6 18 18 6'],
  chart: ['M3 3v18h18M7 16v-4M12 16V7M17 16v-6'],
  copy: ['M8 8h13v13H8Z', 'M16 4V2H2v14h2']
}
export default {
  props: { name: { type: String, default: 'users' } },
  computed: {
    paths() {
      return icons[this.name] || icons.users
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/app-icon.vue